import React from 'react';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPadding} from '@/section';
import {H2Neutral50, PNeutral50} from '@/typography';
import {withBgTeal800} from '@/hocs/withColors';
import Link from '@/links';
import {useTranslations} from 'next-intl';

const Teal800Section = withBgTeal800(SectionPadding);

const WorkWithUs = () => {
  const t = useTranslations('about.workWithUs');

  return (
    <Teal800Section>
      <Container>
        <Grid fluid>
          <Row middle="xs" center="xs" start="lg">
            <Col xs={12} lg={6}>
              <H2Neutral50>{t('title')}</H2Neutral50>
              <PNeutral50>{t('description')}</PNeutral50>
            </Col>
            <Col xs={12} lg={5} lgOffset={1}>
              <Link
                href="//apply.workable.com/careers"
                variant="secondary-trans-border"
                customAttributes={{
                  'data-gtm': 'view-jobs',
                  'data-ui': 'view-jobs'
                }}>
                {t('linkText')}
              </Link>
            </Col>
          </Row>
        </Grid>
      </Container>
    </Teal800Section>
  );
};

export default WorkWithUs;
